import {Map} from 'immutable';
import FreeEntryQuestionV2 from './V2/FreeEntryQuestion.react';
import FreeEntryExplanation from './V2/FreeEntryExplanation.react';
import FreeEntryResponseStats from './V2/FreeEntryQuestionResponseStats.react';
import FreeEntryEditor from './FreeEntryEditor/FreeEntryEditor.react';

export const FreeEntryQuestionType = Map({
  type: 'free-entry',
  label: 'Free Entry',
  questionRenderer: FreeEntryQuestionV2,
  explanationRenderer: FreeEntryExplanation,
  responseStatsRenderer: FreeEntryResponseStats,
  editor: FreeEntryEditor,
  isHidden: false
});
